export const websocketService = {
	connect() {
		/* WebSocket connection logic */
	},
	searchItineraries() {
		/* WebSocket message sending logic */
	},
	searchEvents() {
		/* WebSocket logic */
	},
};
